import React from "react";
import "./NoDataComp.css";

const NoDataComp = ({ 
  message = "No data available.", 
  buttonText = null, 
  onButtonClick = null 
}) => {
  return (
    <div className="no-data-wrapper">
     <svg
  className="no-data-img"
  width="120"
  height="120"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="4" y="16" width="56" height="36" rx="4" fill="#E2E8F0" />
  <path d="M4 16L32 4L60 16" fill="#CBD5E0" />
  <path d="M4 16L32 28L60 16" fill="#EDF2F7" />
  <path d="M32 28V60" stroke="#A0AEC0" strokeWidth="2" />
  <path d="M4 16V52C4 54.2091 5.79086 56 8 56H56C58.2091 56 60 54.2091 60 52V16" stroke="#A0AEC0" strokeWidth="2"/>
</svg>
      <div className="no-data-text">{message}</div>
      {buttonText && onButtonClick && (
        <button className="no-data-btn" onClick={onButtonClick}>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default NoDataComp;
